/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { profileAddSvg, profileSvg } from '../../components/imagepath';
import { useAppointmentForm } from '../../hooks/useAppointmentForm';
import PatientDetailsForm from './PatientDetailsForm';
import AppointmentDetailsForm from './AppointmentDetailsForm';

const AddAppointment = () => {
  const {
    userType,
    setUserType,
    stepvalue,
    AdminUser,
    AllConsultation,
    DrSlotAvailability,
    DrAvailability,
    disabledDate,
    handleCreatePatient,
    fetchDoctorAvailability,
    fetchSlotAvailability,
  } = useAppointmentForm();

  const handleAppointmentSubmit = (values, { setErrors, setSubmitting }) => {
    return
  };

  return (
    <div>
      <Header />
      <Sidebar id="menu-item1" id1="menu-items1" activeClassName="add-staff" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/appoinment-list?page=1">Appointment </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Add Appointment</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="tab-content-set">
                      <ul className="nav">
                        <li>
                          <Link
                            className={userType === 'new' ? 'active' : ''}
                            onClick={e => {
                              e.preventDefault();
                              setUserType('new');
                            }}
                          >
                            <span className="set-about-icon me-2">
                              <img src={profileAddSvg} alt />
                            </span>
                            New Patient
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={userType === 'old' ? 'active' : ''}
                            onClick={e => {
                              e.preventDefault();
                              setUserType('old');
                            }}
                          >
                            <span className="set-about-icon me-2">
                              <img src={profileSvg} alt />
                            </span>
                            Old Patient
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {stepvalue === '1' ? (
                      <PatientDetailsForm userType={userType} onSubmit={handleCreatePatient} />
                    ) : (
                      // steps 2
                      <AppointmentDetailsForm
                        AdminUser={AdminUser}
                        AllConsultation={AllConsultation}
                        DrSlotAvailability={DrSlotAvailability}
                        DrAvailability={DrAvailability}
                        disabledDate={disabledDate}
                        fetchDoctorAvailability={fetchDoctorAvailability}
                        fetchSlotAvailability={fetchSlotAvailability}
                        onSubmit={handleAppointmentSubmit}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default AddAppointment;
